module.exports = __webpack_public_path__ + "static/i4Solutions-349dab000911152b212354cce10768b0.jpg";